<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-12">
                    <np-checkbox v-if="!isView"
                                 :id="`${id}_selected`"
                                 :name="`${name}[selected]`"
                                 :no-wrapper="true"
                                 :disabled="itemIsDisabled(bundle_item)"
                                 :description="bundle_item.service.service_name"
                                 :checked="itemIsSelected(bundle_item)"
                                 :model-value="itemIsSelected(bundle_item)"
                                 @change="setPCIProgramLevel(bundle_item)"
                                 :on-selected="function() {
                                                                      if(!bundle_item.terminal_quantity > 0 ){
                                                                        bundle_item.terminal_quantity = 1
                                                                        bundle_item.selected = true;
                                                                        bundle_item.is_boarding_activated = '1';
                                                                      }
                                                                    }"
                                 :on-deselected="() => {bundle_item.terminal_quantity = 0; bundle_item.selected = false;
                                 bundle_item.is_boarding_activated = '0';
                            bundle_item.service_charges.forEach(obj => obj.selected = '');
                            if(objectIsNotEmpty(bundle_item.service_features)){
                              getBundleItemFeatures(bundle_item).forEach(obj => {
                              obj.selected = '';
                              obj.value = '';
                            })
                            }

                            }">
                    </np-checkbox>
                    <span v-else>   {{ bundle_item.service.service_name }}</span>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <div class="marginBottom10" v-if="itemHasDescription(bundle_item)">
                        <span class="labelLook boldText">{{ lang('description') }}</span>
                        <np-show-less
                            :id="id"
                            :description="bundle_item.service.service_description">
                        </np-show-less>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-7 col-lg-7">
                    <div class="" v-if="itemHasFeatures(bundle_item)">
                        <!--                        <span class="labelLook boldText">{{lang('features')}}</span>-->
                        <template v-if="!!featureDictionary && featureDictionary.pciProgramLevel">
                            <np-responsive v-show="featureDictionary.hasOwnProperty('pciProgramLevel')">
                                <template #label>
                                <span>{{ featureDictionary.pciProgramLevel.feature_name }}</span>
                                </template>
                                <template #input>
                                <div class="form-group">
                                    <np-entry
                                        :model-value="featureDictionary.pciProgramLevel['list_of_values'][featureDictionary.pciProgramLevel.value]"
                                        :label="featureDictionary.pciProgramLevel.value"
                                        :mode="'input'"
                                    >
                                    </np-entry>
                                </div>
                                </template>
                            </np-responsive>
                        </template>
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-12">
                                <np-select2
                                    v-if="isSelectedFeature('pciServiceType') && featureDictionary.pciServiceType.collect_on_boarding === '1' && featureDictionary['pciServiceType']['selected'] === '1'"
                                    :label="featureDictionary.pciServiceType.feature_name"
                                    :placeholder="featureDictionary.pciServiceType.feature_name"
                                    :name="`${name}_pciServiceType`"
                                    :id="`${id}_pciServiceType`"
                                    :key="`pciServiceType`"
                                    :required="featureDictionary.pciServiceType.is_required === '1'"
                                    :check_config="false"
                                    :help-text="!!featureDictionary.pciServiceType.help_text ? featureDictionary.pciServiceType.help_text : ''"
                                    :disabled="featureDictionary.pciServiceType.disabled || isView"
                                    :parameters="getServiceFeatureList(featureDictionary.pciServiceType)"
                                    v-model="featureDictionary.pciServiceType.value">
                                </np-select2>
                            </div>
                            <div class="col-lg-6 col-md-6 col-12">
                                <np-select2
                                    v-if="isSelectedFeature('pciContact')"
                                    :label="featureDictionary.pciContact.feature_name"
                                    :placeholder="featureDictionary.pciContact.feature_name"
                                    :name="`${name}_pciContact`"
                                    :id="`${id}_pciContact`"
                                    :required="featureDictionary.pciContact.is_required === '1'"
                                    :check_config="false"
                                    :help-text="!!featureDictionary.pciContact.help_text ? featureDictionary.pciContact.help_text : ''"
                                    :key="`pciContact`"
                                    :disabled="featureDictionary.pciContact.disabled || isView"
                                    @input="setPCIContactDetail"
                                    :parameters="getServiceFeatureList(featureDictionary.pciContact)"
                                    v-model="featureDictionary.pciContact.value">
                                </np-select2>
                            </div>
                        </div>
                        <np-select2
                            v-if="isSelectedFeature('pciContactDetail')"
                            :label="featureDictionary.pciContactDetail.feature_name"
                            :placeholder="featureDictionary.pciContactDetail.feature_name"
                            :name="`${name}_pciContactDetail`"
                            :id="`${id}_pciContactDetail`"
                            :key="`pciContactDetail`"
                            :help-text="!!featureDictionary.pciContactDetail.help_text ? featureDictionary.pciContactDetail.help_text : ''"
                            :disabled="featureDictionary.pciContactDetail.disabled || isView"
                            @input="prefillPCIContactInformation"
                            :parameters="getServiceFeatureList(featureDictionary.pciContactDetail)"
                            v-model="featureDictionary.pciContactDetail.value">
                        </np-select2>
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-12"
                                 v-if="isSelectedFeature('pciContactFirstName')">
                                <np-input
                                    :label="featureDictionary.pciContactFirstName.feature_name"
                                    :placeholder="featureDictionary.pciContactFirstName.feature_name"
                                    :name="`${name}_pciContactFirstName`"
                                    :id="`${id}_pciContactFirstName`"
                                    :key="`pciContactFirstName`"
                                    :disabled="isView"
                                    :check_config="false"
                                    :rules="['alpha_name']"
                                    :maxlength="featureDictionary.pciContactFirstName.max"
                                    :help-text="!!featureDictionary.pciContactFirstName.help_text ? featureDictionary.pciContactFirstName.help_text : ''"
                                    :required="featureDictionary.pciContactFirstName.required"
                                    v-model="featureDictionary.pciContactFirstName.value">
                                </np-input>
                            </div>
                            <div class="col-lg-6 col-md-6 col-12"
                                 v-if="isSelectedFeature('pciContactLastName')">
                                <np-input
                                    :label="featureDictionary.pciContactLastName.feature_name"
                                    :placeholder="featureDictionary.pciContactLastName.feature_name"
                                    :name="`${name}_pciContactLastName`"
                                    :id="`${id}_pciContactLastName`"
                                    :key="`pciContactLastName`"
                                    :disabled="isView"
                                    :check_config="false"
                                    :rules="['alpha_name']"
                                    :maxlength="featureDictionary.pciContactLastName.max"
                                    :help-text="!!featureDictionary.pciContactLastName.help_text ? featureDictionary.pciContactLastName.help_text : ''"
                                    :required="featureDictionary.pciContactLastName.required"
                                    v-model="featureDictionary.pciContactLastName.value">
                                </np-input>
                            </div>
                        </div>
                        <np-input
                            v-if="isSelectedFeature('pciContactEmailAddress')"
                            :label="featureDictionary.pciContactEmailAddress.feature_name"
                            :placeholder="featureDictionary.pciContactEmailAddress.feature_name"
                            :name="`${name}_pciContactEmailAddress`"
                            :id="`${id}_pciContactEmailAddress`"
                            :key="`pciContactEmailAddress`"
                            :rules="['valid_email', 'required']"
                            :disabled="isView"
                            :check_config="false"
                            :help-text="!!featureDictionary.pciContactEmailAddress.help_text ? featureDictionary.pciContactEmailAddress.help_text : ''"
                            :required="featureDictionary.pciContactEmailAddress.is_required === '1'"
                            v-model="featureDictionary.pciContactEmailAddress.value">
                        </np-input>
                        <div class="row compactInputFormat">
                            <div class="col-12 col-md-12"
                                 v-if="isSelectedFeature('pciContactPhoneIntlCode') || isSelectedFeature('pciContactPhoneNumber')">
                                <label>{{ lang('phone') }}</label>
                            </div>
                          <div class="input-group">
                            <div
                                :class="{'col-12':!isSelectedFeature('pciContactPhoneNumber'), 'col-5':isSelectedFeature('pciContactPhoneNumber')}">
                                <keep-alive>
                                    <np-select2
                                        v-if="isSelectedFeature('pciContactPhoneIntlCode')"
                                        :label="featureDictionary.pciContactPhoneIntlCode.feature_name"
                                        :placeholder="featureDictionary.pciContactPhoneIntlCode.feature_name"
                                        :name="`${name}_pciContactPhoneIntlCode`"
                                        :id="`${id}_pciContactPhoneIntlCode`"
                                        :key="`pciContactPhoneIntlCode`"
                                        :mode="`phone`"
                                        :no-wrapper="true"
                                        :disabled="isView"
                                        :parameters="parameters.PHONE_CODES"
                                        :check_config="false"
                                        :help-text="!!featureDictionary.pciContactPhoneIntlCode.help_text ? featureDictionary.pciContactPhoneIntlCode.help_text : ''"
                                        :required="featureDictionary.pciContactPhoneIntlCode.is_required === '1'"
                                        v-model="featureDictionary.pciContactPhoneIntlCode.value">
                                    </np-select2>
                                </keep-alive>
                            </div>
                            <div
                                :class="{'col-12':!isSelectedFeature('pciContactPhoneIntlCode'), 'col-7':isSelectedFeature('pciContactPhoneIntlCode')}">
                                <np-phone
                                    v-if="isSelectedFeature('pciContactPhoneNumber')"
                                    :name="`${name}_pciContactPhoneNumber`"
                                    :id="`${id}_pciContactPhoneNumber`"
                                    :label="featureDictionary.pciContactPhoneNumber.feature_name"
                                    :placeholder="featureDictionary.pciContactPhoneNumber.feature_name"
                                    :no-wrapper="true"
                                    :rules="['numeric', 'required', 'phone_no_leading_zero']"
                                    :maxlength=" getPhoneNoMaxLengthByIso3( getIso3FromPhoneCode( featureDictionary.pciContactPhoneIntlCode?.value ) ) "
                                    :minlength=" getPhoneNoMinLengthByIso3( getIso3FromPhoneCode( featureDictionary.pciContactPhoneIntlCode?.value ) ) "
                                    :disabled="isView"
                                    :check_config="false"
                                    :help-text="!!featureDictionary.pciContactPhoneNumber.help_text ? featureDictionary.pciContactPhoneNumber.help_text : ''"
                                    :required="featureDictionary.pciContactPhoneNumber.is_required === '1'"
                                    v-model="featureDictionary.pciContactPhoneNumber.value">
                                </np-phone>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-5 col-lg-5">
                    <div v-if="itemHasServiceCharges(bundle_item, isView)">
                        <span class="labelLook" style="font-weight: bold">{{ lang('charges') }}</span>
                        <div class="row">
                            <template v-for="(service_charge, service_charge_idx) in bundle_item.service_charges">
                                <div class="col-12" v-if="!isView">
                                    <np-checkbox
                                        :id="`${id}_service_charge_${service_charge_idx}_selected`"
                                        :name="`${name}[service_charge][${service_charge_idx}][selected]`"
                                        :no-wrapper="true"
                                        :disabled="true"
                                        :description="getServiceChargeDescription(service_charge)"
                                        v-model="service_charge.selected">
                                    </np-checkbox>
                                </div>
                                <div class="col-12" v-else>
                            <span v-if="service_charge.selected === '1'">
                              {{ getServiceChargeDescription(service_charge) }}
                            </span>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import utilMixin from "../utils/mixins";
import applicationMixin from "../utils/application-mixin";
import equipmentMixin from "../utils/equipment-mixin";
import {Multiselect} from 'vue-multiselect';
import {
    NPCheckBox,
    NPEntry,
    NPInput,
    NPNotice, NPPhone,
    NPRadios,
    NPResponsive,
    NPSelect2, NPShowLess,
    NPSkeleton,

} from "netpify/components";
import NpMultiselect from "netpify/components/np-multiselect.vue";

export default {
    name: "equipment-service-pci",
    mixins: [utilMixin, applicationMixin, equipmentMixin],
    components: {
        'np-multiselect': NpMultiselect,
        'np-entry': NPEntry,
        'multiselect': Multiselect,
        'np-radios': NPRadios,
        'np-input': NPInput,
        'np-select2': NPSelect2,
        'np-responsive': NPResponsive,
        'np-skeleton': NPSkeleton,
        'np-checkbox': NPCheckBox,
        'np-notice': NPNotice,
        'np-phone': NPPhone,
        'np-show-less': NPShowLess,
    },
    data() {
        return {
            pciFeatures: {
                'pciProgramLevel': 1,
                'pciServiceType': 2,
                'pciContact': 3,
                'pciContactDetail': 4,
                'pciGroups': 5,
                'pciContactFirstName': 6,
                'pciContactLastName': 7,
                'pciContactEmailAddress': 8,
                'pciContactPhoneNumber': 9,
                'pciContactPhoneIntlCode': 10,
                'pciContactPhoneAreaCode': 11
            },
            pciContact: {
                'pciContactFirstName': 1,
                'pciContactLastName': 1,
                'pciContactEmailAddress': 1,
                'pciContactPhoneNumber': 1,
                'pciContactPhoneIntlCode': 1,
                'pciContactPhoneAreaCode': 1
            },
            pciLevels: {
                'ONE': 'ONE',
                'TWO': 'TWO',
                'THREE': 'THREE',
                'FOUR': 'FOUR',
            },
            pciContactFillingType: {
                'PRE_POPULATE': 'PRE_POPULATE',
                'AUTO_FILLING': 'AUTO_FILLING',
                'NO_DEFAULT': 'NO_DEFAULT',
            },
            pciContactDetailType: {
                'BUSINESS_CONTACT': 'BUSINESS_CONTACT',
                'MAIN_PRINCIPAL': 'MAIN_PRINCIPAL',
                'STORE_CONTACT': 'STORE_CONTACT',
            },
            // featureList: [],
        }
    },
    props: {
        bundle_item: {
            default() {
                return {}
            }
        },
        isStandalone: Boolean,
        id: {
            default() {
                return 'quote' + Math.random().toString()
            }
        },
        name: {
            default() {
                return 'quote' + Math.random().toString()
            }
        },
        feature_dictionary: {
            type: Object,
            default: () => {
                return {};
            }
        },
        isView: Boolean,
        isBundlePackage: Boolean,
        bundlePackageSelected: Boolean,
    },
    mounted() {
        // this.featureList = this.bundle_item.hasOwnProperty('service_features') && this.bundle_item.service_features ?
        //     this.sortedBundleItemFeatures(this.bundle_item) : [];
        if (this.bundleItemIsSelected(this.bundle_item) || this.bundle_item.is_mandatory === '1') {
            this.setPCIProgramLevel()
        }
    },
    computed: {
        totalSellingOptions: function () {
            let total = 0.00;

            if (this.objectIsNotEmpty(this.bundle_item.service_charges)) {
                let selected_service_charges = this.bundle_item.service_charges.filter(obj => obj.selected === '1');

                selected_service_charges.forEach(obj => {
                    if (obj.service_frequency === '1') {
                        let value = !!obj.default_base_charge && obj.default_base_charge !== '' ? obj.default_base_charge :
                            !!obj.maximum_base_charge && obj.maximum_base_charge !== '' ? obj.maximum_base_charge : 0.00;
                        total = parseFloat(total) + parseFloat(value)
                    }
                })
            }

            return this.convertToDecimal(total);
        },
        quoteMap: function () {
            let quote = this.quote;
            const dataMap = {
                pciContactFirstName: 'contact_first_name',
                pciContactLastName: 'contact_last_name',
                pciContactEmailAddress: 'email_address',
                pciContactPhoneNumber: 'telephone_number',
                pciContactPhoneIntlCode: 'ent_telephone_code',
            };

            let data = {};
            Object.keys(dataMap).forEach(key => {
                if (quote.hasOwnProperty(dataMap[key])) {
                    data[key] = quote[dataMap[key]];
                }
            })

            return data;
        },
        featureList: function () {
            return this.bundle_item.hasOwnProperty('service_features') && this.bundle_item.service_features ?
                this.sortedBundleItemFeatures(this.bundle_item) : [];
        },
        featureDictionary: function () {
            let feature_dictionary = {};
            this.featureList.forEach(feature => {
                //TODO we may need to call selectItem on all the required ones
                feature_dictionary[feature['feature_api_code']] = feature;
            });
            return feature_dictionary;
        },
        featureListValuesDictionary: function () {
            // let featureListValues = Object.values(this.parameters['FEATURE_LIST_OF_LISTS_VALUES_PARAM']).find(obj => {
            //     return obj['feature_list_value_external_id'] === pciContact
            // });
            let feature_lists = this.parameters['FEATURE_LIST_OF_LISTS_VALUES_PARAM'];
            // let featureListValues = Object.fromEntries(
            //     Object.entries(feature_lists)
            //         .map(([key, val]) => [val['feature_list_value_external_id'], val])
            // );
            return feature_lists;
        }
    },
    methods: {
        itemHasDescription: function (bundle_item) {
            return bundle_item.service.hasOwnProperty('service_description') &&
                bundle_item.service.service_description !== '';
        },
        itemIsDisabled: function (bundle_item) {
            return this.isView ? true : this.isBundlePackage ? true : this.equipmentIsDisabled(bundle_item);
        },
        prepFeatureDictionary: function (bundle_item) {
            let bundle_item_features = this.getBundleItemFeatures(bundle_item);
            let feature_dictionary = {};
            bundle_item_features.forEach(feature => {
                feature_dictionary[feature['feature_api_code']] = feature;
            });
            return feature_dictionary;
        },
        sortedBundleItemFeatures: function (bundle_item) {
            let vm = this;
            let service_features = bundle_item.service_features.map(obj => obj);
            service_features.sort(function (a, b) {
                let a_order = !!vm['pciFeatures'][a['feature_api_code']] ? vm['pciFeatures'][a['feature_api_code']] : 0;
                let b_order = !!vm['pciFeatures'][b['feature_api_code']] ? vm['pciFeatures'][b['feature_api_code']] : 0;
                return a_order - b_order;
            });
            return service_features;
        },
        isSelectedFeature: function (feature_api_code) {
            if (this.featureDictionary.hasOwnProperty(feature_api_code)
                && this.featureDictionary[feature_api_code]['merchant_visibility'] === '1'
                && this.featureDictionary[feature_api_code]['collect_on_boarding'] === '1'
                && this.featureDictionary[feature_api_code]['selected'] === '1') {

                return true;
            }
            return false;
        },
        prefillPCIContactInformation: function () {

            let pciContactDetail = this.featureDictionary.pciContactDetail.value;
            let pciContactDetailListValue = this.featureListValuesDictionary[pciContactDetail];
            if (pciContactDetail['value'] === this.pciContactDetailType.MAIN_PRINCIPAL) {

            }
        },
        getFeatureValuesFromFeatureDictionary: function(feature_dictionary_key){
            //the assumption is: only one value was configured despite the fact that th config can allow multiple
            let vm = this;
            let feature_code_values = [];
            if (this.featureDictionary.hasOwnProperty(feature_dictionary_key)) {
                let pciFeatureCode = vm.featureDictionary[feature_dictionary_key];
                let feature_code_external_ids = null;
                if (pciFeatureCode['collect_on_boarding'] === this.collect_on_boarding_types.OFFER) {
                    feature_code_external_ids = pciFeatureCode['collect_on_value'];
                } else if (pciFeatureCode['collect_on_boarding'] === this.collect_on_boarding_types.CONFIG) {
                    feature_code_external_ids = pciFeatureCode['alliance_default_value'];
                } else {
                    feature_code_external_ids = pciFeatureCode['collect_on_value'];
                }
                feature_code_values = vm.getAllowedDefaultValues(feature_code_external_ids.split(','));
            }
            return feature_code_values;
        },
        setPCIContactDetail: function () {
            let vm = this;
            // console.log('setPCIContactDetails', this.featureDictionary);
            let filling_type_values = vm.getFeatureValuesFromFeatureDictionary('pciContact');
            let has_filling_type_values = Array.isArray(filling_type_values) && filling_type_values.length > 0;
            let is_pre_populate = has_filling_type_values &&
                filling_type_values.includes(vm.pciContactFillingType.PRE_POPULATE);  //editable
            let is_auto_filling = has_filling_type_values &&
                filling_type_values.includes(vm.pciContactFillingType.AUTO_FILLING); //not editable

            if (is_pre_populate) {
                this.selectItem('pciContactDetail');
            } else if(this.featureDictionary.pciContactDetail) {
                this.featureDictionary.pciContactDetail['selected'] = '';
            }

            //set the pciContact fields (first_name, last_name, ...) to show in the UI
            for (const [key, value] of Object.entries(this.pciContact)) {
                if (this.featureDictionary.hasOwnProperty(key)) {
                    this.selectItem(key, true);
                }
            }

            if (vm.allowPopulate()) {
                for (const [key, value] of Object.entries(vm.pciContact)) {
                    if (vm.featureDictionary.hasOwnProperty(key)) {
                        if (vm.featureDictionary[key]['selected'] === '1') {
                            //vm.featureDictionary[key]['selected'] = '1';
                            if (vm.quoteMap && vm.quoteMap.hasOwnProperty(key)) {
                                vm.featureDictionary[key]['value'] = vm.quoteMap[key];

                                if (is_auto_filling) {
                                    vm.featureDictionary[key]['disabled'] = true;
                                }
                            }
                        }
                    }
                }
            }
        },
        allowPopulate: function () {
            let vm = this;
            let hasPciContactFillingType = this.featureDictionary.hasOwnProperty('pciContact');
            let pciContactFillingType = hasPciContactFillingType ? this.featureDictionary.pciContact : null;
            let isList = hasPciContactFillingType && pciContactFillingType['feature_input_type'] === 'LIST';

            let filling_type_values = vm.getFeatureValuesFromFeatureDictionary('pciContact');
            let has_filling_type_values = Array.isArray(filling_type_values) && filling_type_values.length > 0
            let is_pre_populate = has_filling_type_values &&
                filling_type_values.includes(vm.pciContactFillingType.PRE_POPULATE);  //editable
            let is_auto_filling = has_filling_type_values &&
                filling_type_values.includes(vm.pciContactFillingType.AUTO_FILLING); //not editable

            let all_empty = true;
            if (!!vm.quoteMap) {
                Object.keys(vm.quoteMap).forEach(item => {
                    if (item !== 'pciContactPhoneIntlCode' && !!vm.featureDictionary[item]
                        && !!vm.featureDictionary[item].value && vm.featureDictionary[item].value.length !== 0) {
                        all_empty = false;
                    }
                });
            }

            let allowed_by_pci_filling_business = this.allowPrePopulateByPCIFillingBusiness(vm.quote.ownership_entity_type);

            return isList && (is_pre_populate || is_auto_filling) && all_empty && allowed_by_pci_filling_business;
        },
        allowPrePopulateByPCIFillingBusiness: function (ownership_entity_type) {
            // console.log('allowPrePopulateByPCIFillingBusiness');
            let vm = this;
            if (ownership_entity_type && !!this.featureDictionary) {
                let hasPCIFillingBusiness = this.featureDictionary.hasOwnProperty('pciFillingBusiness');
                let pciFillingBusiness = hasPCIFillingBusiness ? this.featureDictionary['pciFillingBusiness'] : {};
                let isList = hasPCIFillingBusiness && pciFillingBusiness['feature_input_type'] === 'LIST';
                let default_value_codes = isList ?
                    vm.getFeatureValuesFromFeatureDictionary('pciFillingBusiness') : [];

                return Array.isArray(default_value_codes) &&
                    default_value_codes.length > 0 ?
                    default_value_codes.includes(ownership_entity_type) : false
            }

            return false
        },
        getAllowedDefaultValues: function(default_values) {
            // console.log('getAllowedAllianceDefaultValues');
            let vm = this;
            let results = [];
            if (Array.isArray(default_values) && default_values.length > 0) {
                let list_of_lists_values = vm.parameters &&
                    vm.parameters.hasOwnProperty('FEATURE_LIST_OF_LISTS_VALUES_PARAM') ?
                    Object.values(vm.parameters['FEATURE_LIST_OF_LISTS_VALUES_PARAM']) : [];
                let has_list_of_lists_values = Array.isArray(list_of_lists_values) && list_of_lists_values.length > 0

                if (has_list_of_lists_values) {
                    list_of_lists_values.forEach(obj => {
                        let found = obj.hasOwnProperty('feature_list_value_external_id') &&
                            default_values.includes(obj.feature_list_value_external_id)
                        if (found) {
                            results.push(obj.value)
                        }
                    })
                }
            }
            return results
        },
        setPCIGroupCode: function () {
            if (this.featureDictionary.hasOwnProperty('pciGroups')) {
                //if pciGroups is required
                if (this.featureDictionary.pciGroups.is_required === '1') {
                    this.selectItem('pciGroups', true)

                }
            }
        },
        setPCIProgramLevel: function () {
            if (this.featureDictionary.hasOwnProperty('pciServiceType')) {
                this.selectItem('pciServiceType');
            }
            let pciProgramLevelFeature = this.featureDictionary.pciProgramLevel;

            if (!!pciProgramLevelFeature) {

                this.selectItem('pciProgramLevel');
                if (pciProgramLevelFeature.selected === '1') {
                    let projected_annual_volume = parseFloat(this.quote.monthly_card_turnover) * 12;
                    let all_transactions_total = 0.8 * (projected_annual_volume / parseFloat(this.quote.avg_tran_value));
                    let ecom_transactions_total = all_transactions_total * (parseFloat(this.quote.sales_internet_perc) / 100);

                    let pci_level = this.pciLevels.FOUR;
                    if (all_transactions_total > 6000000) {
                        // ONE
                        pci_level = this.pciLevels.ONE;
                    } else if (all_transactions_total >= 1000000 && all_transactions_total <= 6000000) {
                        // TWO
                        pci_level = this.pciLevels.TWO;
                    } else if (all_transactions_total < 1000000 && ecom_transactions_total >= 20000) {
                        // THREE
                        pci_level = this.pciLevels.THREE;
                    }

                    let feature_lists = this.parameters['FEATURE_LIST_OF_LISTS_VALUES_PARAM'];
                    let value = Object.values(feature_lists).find(list_value => {
                        return list_value['value'] === pci_level && pciProgramLevelFeature['list_of_values'].hasOwnProperty(list_value['feature_list_value_external_id'])
                    });
                    pciProgramLevelFeature['value'] = value['feature_list_value_external_id'];

                    if (pci_level === this.pciLevels.FOUR && this.featureDictionary.hasOwnProperty('pciContact')) {
                        this.selectItem('pciContact');
                        this.setPCIContactDetail();
                    }
                    this.$forceUpdate()

                    this.setPCIGroupCode()
                } else {
                    pciProgramLevelFeature.value = null;
                    this.$forceUpdate()
                }

                //set service charges
                if (this.npPropertyExistAndIsArray(this.bundle_item, 'service_charges')) {
                    this.bundle_item.service_charges.forEach(obj => {
                        obj.selected = pciProgramLevelFeature.selected
                    })
                }
            }
        },
        selectItem: function (item, is_required = false) {
            if (this.featureDictionary.hasOwnProperty(item)) {
                //set value on select
                let feature_value = !!this.featureDictionary[item]['value'] ? this.featureDictionary[item]['value'] :
                    (this.featureDictionary[item].hasOwnProperty('collect_on_value') ?
                        this.featureDictionary[item]['collect_on_value'] : this.featureDictionary[item]['default_value']);
                this.featureDictionary[item]['value'] = feature_value;

                //set the disabled field based on collect_on_boarding
                if (this.featureDictionary[item]['collect_on_boarding'] === this.collect_on_boarding_types.OFFER) {
                    this.featureDictionary[item]['disabled'] = true
                } else if (this.featureDictionary[item]['collect_on_boarding'] === this.collect_on_boarding_types.CONFIG) {
                    this.featureDictionary[item]['disabled'] = true;
                } else {
                    this.featureDictionary[item]['disabled'] = false;
                }

                this.featureDictionary[item]['selected'] = '1';

                if (!!is_required) {
                    this.featureDictionary[item]['is_required'] = '1';
                }
            }

            // if(this.featureDictionary[item]['collect_on_boarding'] ===  this.collect_on_boarding_types.OFFER) {
            //     this.featureDictionary[item]['value'] = this.featureDictionary[item]['collect_on_value'];
            //     this.featureDictionary[item]['disabled'] = true;
            // }
        },
        itemIsSelected: function (bundle_item) {
            return this.isBundlePackage ? this.bundlePackageSelected ? '1' : '0' : this.equipmentIsSelected(bundle_item);
        },
        getServiceChargeDescription: function (service_charge) {
            return service_charge.service_item_name + ': ' + this.getServiceCharge(service_charge);
        },
        getPCIFeatureList: function (feature) {
            let feature_list = [];
            if (feature.hasOwnProperty('list_of_values') && Object.entries(feature.list_of_values).length > 0) {
                for (const [key, value] of Object.entries(feature.list_of_values)) {
                    feature_list.push({id: key, text: value})
                    //TODO add condition for restricted_values
                }
            }
            return feature_list;
        },
        getFeatureValue: function (feature) {
            let feature_value = !!feature.value ? feature.value : feature.default_value

            if (feature.feature_input_type === this.types.LIST) {
                let feature_list = this.getFeatureList(feature);
                let matched_value = feature_list.find(obj => obj.id === feature_value);

                return !!matched_value ? `(${matched_value.text})` : '';
            } else {
                return feature_value !== '' ? `(${feature_value})` : '';
            }
        }
    }
}
</script>

<style scoped>
ul:not(.nav-pills) {
    list-style: none;
}

li:not(.nav-item) {
    font-weight: lighter;
    font-size: 0.8em;
}

li:not(.nav-item):before {
    content: "\f054"; /* FontAwesome Unicode fa-chevron-right*/
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    display: inline-block;
    margin-left: -1.3em; /* same as padding-left set on li */
    width: 1.3em; /* same as padding-left set on li */
}

/*.avatar-small:hover {*/
/*    box-shadow: 0 0 2px 1px rgba(66, 153, 225, 1);*/
/*    -ms-transform: scale(2.5); !* IE 9 *!*/
/*    -webkit-transform: scale(2.5); !* Safari 3-8 *!*/
/*    transform: scale(2.5);*/
/*    cursor: pointer;*/
/*    z-index: 99999;*/
/*}*/

.vue-radio-checkbox.np-checkbox.default.form-group {
    min-height: 0 !important;
}


</style>
